import { render } from "./common-footer.vue?vue&type=template&id=07deff42&scoped=true"
const script = {}

import "./common-footer.vue?vue&type=style&index=0&id=07deff42&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07deff42"]])

export default __exports__